import Phone from './Phone'
import Email from './Email'
import Address from './Address'
import CanadianProvinces from './Address'

export {
    Phone, Email, Address, CanadianProvinces
}